// extracted by css-extract-rspack-plugin
export default {"cls1":"CitingSourcesCard-cls1_Wmf","cls2":"CitingSourcesCard-cls2_pPg CitingSourcesCard-cls1_Wmf"};